import { useMemo } from "react";
import moment from "moment";
import { intl } from "LocaleWrapper";
import { useQuery } from "@apollo/client";

import { Card, PageHeader } from "@cofano/cck";
import { Box, Typography } from "@mui/material";

import useLayout from "components/layout/useLayout";
import Helmet from "components/helmet/Helmet";

import { Language } from "imports/Utils";

import ProductsAdnTable from "view/products/components/table/ProductsAdnTable";
import ProductAdnDetails from "view/products/components/details/ProductAdnDetails";

import { GetAdnProductListDocument } from "__generated__/view/products/graphql/product.queries.generated";
import { AdnGoodFragment } from "__generated__/view/products/graphql/product.fragments.generated";

const ProductsAdn = () => {

	const { data, loading } = useQuery(GetAdnProductListDocument);

	const layout = useLayout();

	const handleRowClick = (row: AdnGoodFragment) => {
		layout.setDrawerSettings({
			open: true,
			title: intl.formatMessage({ id: "PRODUCT" }),
			content: (
				<Box p={2}>
					<ProductAdnDetails adnGood={row} />
				</Box>
			),
			size: "normal",
			variant: "overlay",
		});
	};

	const sortedAdnGoods = useMemo(() => {
		const goods = data?.adnProductList?.goods ?? [];
		return [ ...goods ].sort((a, b) => (a.adnCode ?? 0) - (b.adnCode ?? 0));
	}, [ data?.adnProductList?.goods ]);

	return (
		<div>
			<PageHeader>
				<PageHeader.Title>
					<Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
						{Language("PRODUCT_ADN")}

						{data?.adnProductList?.publicationDate && (
							<Box sx={{ display: "inline-flex", alignItems: "center", gap: 0.5 }}>
								<Typography variant="caption" sx={{ lineHeight: 1, fontWeight: 600 }}>
									{Language("PRODUCT_IDTF_PUBLICATION")}:
								</Typography>

								<Typography variant="caption" sx={{ lineHeight: 1, fontWeight: 600 }}>
									{moment(data?.adnProductList?.publicationDate).format("L")}
								</Typography>
							</Box>
						)}
					</Box>

					<Helmet title={intl.formatMessage({ id: "PRODUCT_ADN" })} />
				</PageHeader.Title>
			</PageHeader>

			<Card disablePadding>
				<ProductsAdnTable
					content={sortedAdnGoods}
					contentLoading={loading}
					onRowClick={handleRowClick} />
			</Card>
		</div>
	);
};

export default ProductsAdn;
